import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue';

/**
 * EzTableRowコンポーネントのプロパティ
 * @property {string[]} gridTemplateColumns - グリッドの各列の幅を定義する配列
 * @property {boolean} isHighlighted - 行をハイライト表示するかどうか
 * @property {boolean} isExpanded - 行が展開されているかどうか
 * @property {boolean} isLoading - 行のロード中状態を表すかどうか
 * @property {boolean} isError - エラー状態を表すかどうか
 * @property {boolean} isChild - 子行かどうか
 */
type Props = {
  gridTemplateColumns: string[];
  isHighlighted?: boolean;
  isExpanded?: boolean;
  isLoading?: boolean;
  isError?: boolean;
  isChild?: boolean;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'EzTableRow',
  props: {
    gridTemplateColumns: {},
    isHighlighted: { type: Boolean, default: false },
    isExpanded: { type: Boolean, default: false },
    isLoading: { type: Boolean, default: false },
    isError: { type: Boolean, default: false },
    isChild: { type: Boolean, default: false }
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "33b59a36": (gridTemplateColumnsStyle.value)
}))

const props = __props;

const emits = __emit;

const gridTemplateColumnsStyle = computed(() => {
  return props.gridTemplateColumns.join(' ');
});

/**
 * 行のCSSクラスを計算
 */
const rowClasses = computed(() => {
  return {
    'table__row--highlighted': props.isHighlighted,
    'table__row--expanded': props.isExpanded,
    'table__row--loading': props.isLoading,
    'table__row--error': props.isError,
    'table__row--child': props.isChild,
  };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["table__row", rowClasses.value]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('click')))
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})